import type { CSSProperties } from 'react';
import { forwardRef } from 'react';
import styled from 'styled-components';
import type {
  FontValue,
  TextStyleValue
} from '@elfsight/configurator-contracts';
import { useBanner } from '../../bannerProvider';
import type { BlockProps } from '../_block';
import { Block } from '../_block';

export type TextBlockProps = BlockProps & {
  text: string;
  color: string;
  fontFamily: FontValue;
  font: TextStyleValue;
  mobileFont: TextStyleValue;
  applyMobileSettings: boolean;
};

export const TextBlock = forwardRef<HTMLDivElement, TextBlockProps>(
  (
    {
      text,
      color,
      fontFamily,
      font,
      mobileFont,
      applyMobileSettings,
      style,
      ...forwardingProps
    },
    forwardingRef
  ) => {
    const { contentDirection } = useBanner();

    const isRow = contentDirection === 'row';
    const currentFont = applyMobileSettings ? mobileFont : font;

    const rowStyle: CSSProperties = {
      ...style,
      flex: 1,
      textAlign: 'start',
      maxWidth: 'fit-content',
      flexBasis: '10em'
    };

    const blockStyle = isRow ? rowStyle : style;

    return (
      <Block {...forwardingProps} ref={forwardingRef} style={blockStyle}>
        <TextHTML
          _color={color}
          _fontFamily={fontFamily?.value}
          style={currentFont}
          dangerouslySetInnerHTML={{ __html: text }}
        />
      </Block>
    );
  }
);

const TextHTML = styled.div<{
  _color: string;
  _fontFamily: string | undefined;
}>`
  line-height: 1.32;
  color: ${({ _color }) => _color};
  ${({ _fontFamily }) => _fontFamily && `font-family: ${_fontFamily};`}

  & a {
    color: inherit;
  }
`;
